// ISO 639-2/B 3-letter codes mapping for language_id
export const LanguageCodesThreeLetter = {
  ar: 'ARA',
  bg: 'BUL',
  cs: 'CZE',
  cz: 'CZE',
  de: 'DEU',
  en: 'ENG',
  es: 'SPA',
  fi: 'FIN',
  fr: 'FRA',
  id: 'IND',
  it: 'ITA',
  ja: 'JPN',
  jp: 'JPN',
  ko: 'KOR',
  nl: 'NLD',
  pl: 'POL',
  pt: 'POR',
  ro: 'RON',
  ru: 'RUS',
  sv: 'SWE',
  th: 'THA',
  tr: 'TUR',
  vi: 'VIE',
  zh: 'CHI',
} as const;

export const getThreeLetterCountryCode = (langCode: string): string => {
  if (langCode.startsWith('zh-')) {
    return LanguageCodesThreeLetter.zh;
  }
  const primaryLang: keyof typeof LanguageCodesThreeLetter = langCode
    .split('-')[0]
    .toLowerCase() as keyof typeof LanguageCodesThreeLetter;
  return LanguageCodesThreeLetter[primaryLang] || LanguageCodesThreeLetter.en;
};
